import { render } from "./App.vue?vue&type=template&id=87b7908c&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=87b7908c&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=87b7908c&lang=css"

import exportComponent from "D:\\Express\\北方\\Agent_SYSTEM\\AgentWeb\\Vue\\agentweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87b7908c"]])

export default __exports__